var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['wrapper']},[(_vm.succeess)?_c('ds-confirmed-icon'):_c('ds-unconfirmed-icon'),_c('div',{class:_vm.$style['right-wrapper']},[_c('div',{class:_vm.$style['address']},[_vm._v(_vm._s(_vm.domain))]),_c('div',{class:_vm.$style['response']},[_vm._v(_vm._s(_vm.response))])])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-113ec944","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/dashboard/components/record-response.vue
// module id = null
// module chunks = 